import ActionTypes, { TFinalTestState } from './types';
import { Actions, TDefRequest } from '../Action';

const GetFinalTestAction = new Actions('GET_FINAL_TEST', ActionTypes);
export interface TypeGetFinalTestR extends TDefRequest {
  event_id: number;
}
export const GetFinalTest = {
  request: (payload: TypeGetFinalTestR) => GetFinalTestAction.request(payload),
  success: (payload: TFinalTestState['data']) => GetFinalTestAction.success(payload || {}),
  error: (message: string) => GetFinalTestAction.error(message),
};

const SendFinalTestAction = new Actions('SEND_FINAL_TEST', ActionTypes);
export interface TypeSendFinalTestR extends TDefRequest {
  data: {
    event_id: number;
    data: { questionId: number; answerId: number }[];
  };
}
export const SendFinalTest = {
  request: (payload: TypeSendFinalTestR) => SendFinalTestAction.request(payload),
  success: (payload: TFinalTestState['data']) => SendFinalTestAction.success(payload || {}),
  error: (message: string) => SendFinalTestAction.error(message),
};
